import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import PrivateRoutes from "./components/PrivateRoutes";
import { Loading } from "./pages/alert/Loading";

const KezdolapPage = lazy(() => import("./pages/kezdolap/KezdolapPage"));
const Rolam = lazy(() => import("./pages/kezdolap/Rolam"));
const Profil = lazy(() => import("./pages/userkezeles/profil/Profil"));
const LoginPage = lazy(() => import("./pages/userkezeles/LoginPage"));
const ForgotPassword = lazy(() => import("./pages/userkezeles/ForfotPassword"));
const PasswordResetConfirm = lazy(() =>
  import("./pages/userkezeles/PasswordResetConfirm")
);
const RegistrationPage = lazy(() =>
  import("./pages/userkezeles/RegistrationPage")
);
const PrivacyPolicy = lazy(() => import("./pages/userkezeles/PrivacyPolicy"));
const Helyezetek = lazy(() => import("./pages/userkezeles/Helyezetek"));
const Iranyzat = lazy(() => import("./pages/iranyzatok/Iranyzat"));
const IranyzatDetail = lazy(() => import("./pages/iranyzatok/IranyzatDetail"));
const GyakorloOpciok = lazy(() => import("./pages/gyakorlo/GyakorloOpciok"));
const Gyakorlo = lazy(() => import("./pages/gyakorlo/Gyakorlo"));
const HibajelentesTargyalo = lazy(() =>
  import("./pages/kozosseg/HibajelentesTargyalo")
);
const UjHibajelentes = lazy(() =>
  import("./pages/analogiadb/hibajelentes/UjHibajelentes")
);
const FejezetList = lazy(() => import("./pages/leckek/FejezetList"));
const Lecke = lazy(() => import("./pages/leckek/Lecke"));
const Test = lazy(() => import("./pages/leckek/Test"));
const CourseForm = lazy(() => import("./pages/leckek/course/CourseForm"));
const CourseList = lazy(() => import("./pages/leckek/course/CourseList"));
const LessonList = lazy(() => import("./pages/leckek/lessons/LessonList"));
const LessonForm = lazy(() => import("./pages/leckek/lessons/LessonForm"));
const LevelForm = lazy(() => import("./pages/leckek/lessons/LevelForm"));
const LevelExercise = lazy(() =>
  import("./pages/leckek/levelexercise/LevelExercise")
);
const NewsFeed = lazy(() => import("./pages/kozosseg/hir/NewsFeed"));
const JegyJatek = lazy(() => import("./pages/gyakorlo/jatekok/JegyJatek"));
const AstrologyGame = lazy(() => import("./pages/jatekok/AstrologyGame"));
const AnalogiaSearch = lazy(() =>
  import("./pages/analogiadb/kereso/AnalogiaKereso")
);
const Szemely = lazy(() => import("./pages/szemely/szemelyek/Szemely"));
const SzemelyDetail = lazy(() =>
  import("./pages/szemely/szemelydetails/SzemelyDetails")
);
const KepletekListaja = lazy(() =>
  import("./pages/szemely/asztrologia/KepletekListaja")
);
const Keplet = lazy(() => import("./pages/szemely/asztrologia/Keplet"));
const ArcolvasasElemzes = lazy(() =>
  import("./pages/szemely/arcolvasas/ArcolvasasElemzes")
);
const AdminLog = lazy(() => import("./pages/admin/AdminLog"));
const BolygokPage = lazy(() =>
  import("./pages/analogiadb/AlapAnalogiaTarolok").then((m) => ({
    default: m.BolygokPage
  }))
);
const JegyekPage = lazy(() =>
  import("./pages/analogiadb/AlapAnalogiaTarolok").then((m) => ({
    default: m.JegyekPage
  }))
);
const HazakPage = lazy(() =>
  import("./pages/analogiadb/AlapAnalogiaTarolok").then((m) => ({
    default: m.HazakPage
  }))
);
const HUHkPage = lazy(() =>
  import("./pages/analogiadb/AlapAnalogiaTarolok").then((m) => ({
    default: m.HUHkPage
  }))
);
const HJkPage = lazy(() =>
  import("./pages/analogiadb/AlapAnalogiaTarolok").then((m) => ({
    default: m.HJkPage
  }))
);
const BJkPage = lazy(() =>
  import("./pages/analogiadb/AlapAnalogiaTarolok").then((m) => ({
    default: m.BJkPage
  }))
);
const BHkPage = lazy(() =>
  import("./pages/analogiadb/AlapAnalogiaTarolok").then((m) => ({
    default: m.BHkPage
  }))
);
const BolygoPage = lazy(() =>
  import("./pages/analogiadb/AnalogiaPage").then((m) => ({
    default: m.BolygoPage
  }))
);
const JegyPage = lazy(() =>
  import("./pages/analogiadb/AnalogiaPage").then((m) => ({
    default: m.JegyPage
  }))
);
const HazPage = lazy(() =>
  import("./pages/analogiadb/AnalogiaPage").then((m) => ({
    default: m.HazPage
  }))
);
const HUHPage = lazy(() =>
  import("./pages/analogiadb/AnalogiaPage").then((m) => ({
    default: m.HUHPage
  }))
);
const HJPage = lazy(() =>
  import("./pages/analogiadb/AnalogiaPage").then((m) => ({ default: m.HJPage }))
);
const BJPage = lazy(() =>
  import("./pages/analogiadb/AnalogiaPage").then((m) => ({ default: m.BJPage }))
);
const BHPage = lazy(() =>
  import("./pages/analogiadb/AnalogiaPage").then((m) => ({ default: m.BHPage }))
);
const BesorolatlanAnalogiak = lazy(() =>
  import("./pages/analogiadb/besorolatlananalogiak/Besorolatlananalogiak")
);
const CsaladfaPage = lazy(() =>
  import("./pages/szemely/csaladfa/CsaladfaPage")
);
const FunkciokListaja = lazy(() => import("./pages/kezdolap/FunkciokListaja"));

const LazyRoutes = () => (
  <Suspense
    fallback={
      <div className="text-center p-5">
        <Loading size={60} />
      </div>
    }
  >
    <Routes>
      <Route element={<PrivateRoutes />}>
        <Route path="/profil" element={<Profil />} />
        <Route path="/kozosseg" element={<NewsFeed />} />
        <Route path="/gyakorloopciok" element={<GyakorloOpciok />} />
        <Route path="/gyakorlo/:id" element={<Gyakorlo />} />
        <Route path="/helyezettek" element={<Helyezetek />} />
        <Route
          path="/uj-hibajelentes/:analogiaid"
          element={<UjHibajelentes />}
        />
        <Route
          path="/hibajelentestargyalo"
          element={<HibajelentesTargyalo />}
        />
        <Route path="/leckefejezetek" element={<FejezetList />} />
        <Route path="/lecke/:id" element={<Lecke />} />
        <Route path="/lecke/:id/test" element={<Test />} />
        <Route path="/analogiakereso" element={<AnalogiaSearch />} />
        <Route path="/iranyzatok" element={<Iranyzat />} />
        <Route path="/iranyzat/:id" element={<IranyzatDetail />} />
        <Route path="/szemelyek" element={<Szemely />} />
        <Route path="/szemely/:id" element={<SzemelyDetail />} />
        <Route
          path="/besorolatlananalogiak"
          element={<BesorolatlanAnalogiak />}
        />
        <Route path="/adminlog" element={<AdminLog />} />
        <Route path="/asztrologia/:id" element={<KepletekListaja />} />
        <Route path="/keplet/:id" element={<Keplet />} />
        <Route path="/szemely/:id/arckepek" element={<ArcolvasasElemzes />} />
        <Route path="/csaladfa/:id" element={<CsaladfaPage />} />
      </Route>

      {/* Tanulóközpont */}
      <Route path="/tanulokozpont" element={<CourseList />} />
      <Route path="/tanulokozpont/new" element={<CourseForm />} />
      <Route path="/tanulokozpont/:id" element={<CourseForm />} />
      <Route path="/tanulokozpont/:courseId/lecke" element={<LessonList />} />
      <Route
        path="/tanulokozpont/:courseId/lecke/new"
        element={<LessonForm />}
      />
      <Route
        path="/tanulokozpont/:courseId/lecke/:lessonId"
        element={<LessonForm />}
      />
      <Route
        path="/tanulokozpont/:courseId/lecke/:lessonId/melyseg/new"
        element={<LevelForm />}
      />
      <Route
        path="/tanulokozpont/:courseId/lecke/:lessonId/melyseg/:levelId"
        element={<LevelForm />}
      />
      <Route
        path="/tanulokozpont/:courseId/lecke/:lessonId/melyseg/:levelId/start"
        element={<LevelExercise />}
      />

      <Route path="/jegyjatek" element={<JegyJatek />} />
      <Route path="/zoodiakusjatek" element={<AstrologyGame />} />

      {/* ÚJ: Funkciók listája oldal */}
      <Route path="/funkciok" element={<FunkciokListaja />} />

      <Route path="/bolygok" element={<BolygokPage />} />
      <Route path="/bolygok/:id" element={<BolygoPage />} />
      <Route path="/jegyek" element={<JegyekPage />} />
      <Route path="/jegyek/:id" element={<JegyPage />} />
      <Route path="/hazak" element={<HazakPage />} />
      <Route path="/hazak/:id" element={<HazPage />} />
      <Route path="/bolygokJegyekben" element={<BJkPage />} />
      <Route path="/bolygokHazakban" element={<BHkPage />} />
      <Route path="/hazakJegyekben" element={<HJkPage />} />
      <Route path="/hazakUraHazakban" element={<HUHkPage />} />
      <Route path="/bolygokJegyekben/:id" element={<BJPage />} />
      <Route path="/bolygokHazakban/:id" element={<BHPage />} />
      <Route path="/hazakJegyekben/:id" element={<HJPage />} />
      <Route path="/hazakUraHazakban/:id" element={<HUHPage />} />

      <Route path="/register" element={<RegistrationPage />} />
      <Route path="/rolam" element={<Rolam />} />
      <Route path="/" element={<KezdolapPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/elfelejtett-jelszo" element={<ForgotPassword />} />
      <Route
        path="/elfelejtett-jelszo-visszaallitas/:userid/:token"
        element={<PasswordResetConfirm />}
      />
      <Route path="/adatkezelesi-nyilatkozat" element={<PrivacyPolicy />} />
    </Routes>
  </Suspense>
);

export default LazyRoutes;
